import { useEffect, useRef } from 'react';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { initializeAnalytics, identifyUser, clearAnalyticsIdentity } from '@/utils/analytics';

interface AnalyticsProviderProps {
  children: React.ReactNode;
}

export function AnalyticsProvider({ children }: AnalyticsProviderProps) {
  const { user, isAuthenticated } = useAuth();
  const initializedRef = useRef(false);
  const identifiedUserIdRef = useRef<string | null>(null);

  // Initialize analytics once on mount
  useEffect(() => {
    if (!initializedRef.current) {
      initializeAnalytics();
      initializedRef.current = true;
    }
  }, []);

  // Identify user when authenticated
  useEffect(() => {
    if (isAuthenticated && user && identifiedUserIdRef.current !== user.id) {
      identifyUser(user);
      identifiedUserIdRef.current = user.id;
    } else if (!isAuthenticated && identifiedUserIdRef.current) {
      clearAnalyticsIdentity();
      identifiedUserIdRef.current = null;
    }
  }, [isAuthenticated, user]);

  return <>{children}</>;
}
